import { Identification } from '@/shared/models/view/identification-viewmodel';
import { IIdentification } from '@/shared/models/api/identification-model';

export class IdentificationMapper {
    public mapIdentification(identification: IIdentification): Identification {
        return new Identification(
            identification.code,
            identification.name
        )
    }
}